"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSmartCaptchaLoader = exports.callbacks = void 0;
const react_1 = require("react");
const load_script_1 = require("../lib/load-script");
const constants_1 = require("../shared/constants");
/**
 * @internal
 */
exports.callbacks = [];
let startLoading = false;
function useSmartCaptchaLoader() {
    const [smartCaptcha, setSmartCaptcha] = react_1.useState();
    react_1.useEffect(() => {
        if (smartCaptcha !== undefined) {
            return;
        }
        if (window.__onSmartCaptchaReady === undefined) {
            window.__onSmartCaptchaReady = () => {
                exports.callbacks.forEach((callback) => callback());
            };
        }
        if (window.smartCaptcha) {
            setSmartCaptcha(window.smartCaptcha);
        }
        const index = exports.callbacks.push(() => setSmartCaptcha(window.smartCaptcha));
        if (!startLoading) {
            load_script_1.loadScript(constants_1.API_LINK);
            startLoading = true;
        }
        return () => {
            exports.callbacks.splice(index, 1);
        };
    }, [smartCaptcha]);
    return smartCaptcha;
}
exports.useSmartCaptchaLoader = useSmartCaptchaLoader;
